import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { useAuth } from '@/shared/auth';
import { routeHistoryStore } from './routeHistoryStore';

export const RouteHistoryTracker = () => {
  const location = useLocation();
  const { sessionUser } = useAuth();
  // Reset history when the authenticated user changes so a location recorded
  // before logout can't be proposed as a "back destination" after re-login.
  const lastUserIdRef = useRef<string | null | undefined>(undefined);

  useEffect(() => {
    const id = sessionUser?.id ?? null;
    if (lastUserIdRef.current === undefined) {
      lastUserIdRef.current = id;
      return;
    }
    if (lastUserIdRef.current !== id) {
      routeHistoryStore.reset();
      lastUserIdRef.current = id;
    }
  }, [sessionUser?.id]);

  useEffect(() => {
    routeHistoryStore.record(location);
  }, [location]);

  return null;
};
